import {OperationStatus} from "@/interfaces";

enum SchedulingComponentStatus {
  Ok = "ok",
  UpcomingShortage = "upcoming_shortage",
  Shortage = "shortage",
}

type SchedulingComponentStatusOperation = {
  op_status: OperationStatus;
  status_done_at?: string;
  status_ongoing_at?: string;
};

export {SchedulingComponentStatus, SchedulingComponentStatusOperation};
